import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x6c01,
  properties: ["read", "write", "notify"],
};
export function generateMockDURNofifyData(): DomianControl.DSTNotifyData {
  const data = getMockDataByKeys([
    // 实际横摆速度
    "UIRx_ABSSplitCtrlSts_BCh1",
    // 后轮角度
    "UIRx_AxleStAng_FA",
    // 方向盘角度
    "UIRx_AxleStAng_RA",
    // 前轮转向比
    "UIRx_FrontGearRto",
    // 原始横摆速度
    "UIRx_ACUYawRate",
    // 后轮转向比
    "UIRx_RearGearRto",
    // 方向盘角度
    "UIRx_SBW_HWAAng",
    // 车速
    "UIRx_VehSpd",
    // 左前轮附着
    "UIRx_mueFL",
    // 右前轮附着
    "UIRx_mueFR",
    // 左后轮附着
    "UIRx_mueRL",
    // 右后轮附着
    "UIRx_mueRR",
  ]);
  return data;
}
